const environment = {
  serverUrl:
    process.env.NODE_ENV !== "production"
      ? "http://localhost:3000"
      : "https://api.diamondshub.it",
};

export default environment;
